module.exports = __webpack_public_path__ + "static/media/3787.6ad99a46.jpg";